import { useSelector } from 'react-redux';
import { selectResidentialProxies } from 'store/slices/PricingSlice';
import ProductPricingCard from '../../ProductPricingCard';
import { selectCurrentResidentialProxies } from 'store/slices/GeneralSlice';
import ResidentialTab from './Tab';

const ResidentialPricingCard = ({ sliderValue, onChange }) => {
    const data = useSelector(selectResidentialProxies);
    const residentialProxies = useSelector(selectCurrentResidentialProxies)

    return (
        <ProductPricingCard
            data={data}
            fields={residentialProxies}
            sliderValue={sliderValue}
            additionalComponent={<ResidentialTab sliderValue={sliderValue} onChange={onChange} />}
        />
    );
};

export default ResidentialPricingCard;
